import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { BuildAssembly, BuildAssemblyDetail, Part, PartAliasType, PurchaseOrder, PurchaseOrderLine, PurchaseOrderLineItem, Vendor } from 'app/core/model/entity-model';
import { PartDetailComponent } from 'app/parts/part-detail/part-detail.component';
import { PartSearchComponent } from 'app/parts/part-search/part-search.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-build-assembly-detail',
    templateUrl: './build-assembly-detail.component.html',
    styleUrls: ['./build-assembly-detail.component.scss'],
    standalone: false
})
export class BuildAssemblyDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    buildAssembly: BuildAssembly;
    assemblyId: any;
    details: any;

    createPO = false;
    vendors: any[];
    vendorId: number;
    shipAddresses = [
        {
            id: 1,
            name: 'Genesis - Assembly',
            companyName: 'Genesis Trailers, Inc.',
            address1: '92 E. 64th Street',
            city: 'Holland',
            state: 'MI',
            zip: '49423',
            phone: '(616) 394-0895',
        },
        {
            id: 2,
            name: 'Genesis - Weld Shop',
            companyName: 'Genesis Trailers, Inc.',
            address1: '92 E. 64th Street',
            city: 'Holland',
            state: 'MI',
            zip: '49423',
            phone: '(616) 394-0895',
        },
    ];

    readOnly = true;
    processing = false;
    showAsDialog = false;

    isToastVisible = false;
    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';

    saving = false;

    @ViewChild('linesGrid') linesGrid: DxDataGridComponent;

    constructor(
        private uow: GenesisUnitOfWork,
        private route: ActivatedRoute,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        protected location: Location,
        private utility: UtilityService
    ) {}

    // @HostListener allows us to also guard against browser refresh, close, etc.
    @HostListener('window:beforeunload')
    canDeactivate() {
        return !this.hasChanges();
    }
    hasChanges() {
        return this.uow.hasChanges();
    }

    async ngOnInit() {
        const statuses = this.uow.lookups.buildAsseblyStatuses;
        if (!this.assemblyId) this.assemblyId = this.route.snapshot.params.id;
        this.vendors = await this.uow.getVendors();
        await this.getData();
    }

    async getData() {
        if (this.assemblyId === 'new') {
            this.buildAssembly = this.uow.buildAssemblies.createEntity() as BuildAssembly;
            this.buildAssembly.statusId = 1;
            this.buildAssembly.createDate = new Date();
            this.buildAssembly.buildDate = new Date();
            this.buildAssembly.createdBy = this.auth.currentUser.userName;
        } else {
            this.buildAssembly = (await this.uow.buildAssemblies.byId(this.assemblyId, 'details')) as BuildAssembly;
        }
        this.getDataLines();
        this.readOnly = this.buildAssembly.statusId === BuildAssembly.Statuses.Complete;
    }

    getDataLines() {
        this.details = this.buildAssembly.details;
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async onRowUpdating(e) {}

    async onRowDoubleClick(e) {
        console.log(e);
        if (!e.data || !e.data.id) return;

        const orderId = this.buildAssembly.id;
        if (!orderId) return;
        const modalRef = this.modalService.show(PartDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                showAsDialog: true,
                partId: e.data.partId,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });
    }

    async removeOrderLine() {
        if (this.linesGrid.instance.getSelectedRowsData().length === 0 || this.processing) return;
        this.appInfo.pleaseWaitShow();
        const selectedLine = this.linesGrid.instance.getSelectedRowsData()[0];
        selectedLine.entityAspect.setDeleted();
        await this.uow.commit();
        this.getDataLines();
        this.appInfo.pleaseWaitHide();
        this.processing = false;
    }

    async addLines(mode: any) {
        let partTypeIds = [];
        let partOptions = [];
        const line = this.linesGrid.instance.getSelectedRowsData()[0];

        partTypeIds = (await this.uow.partTypes.all()).map((partType: any) => partType.id);

        const modalRef = this.modalService.show(PartSearchComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                showAsDialog: true,
                partTypeIds: partTypeIds,
                partOptions: partOptions,
                mode: mode,
                columnLimitMode: true,
                showSideBar: true,
                storageKey: 'part-search-grid-buildAssemblies',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                this.saving = true;
                const parts = (await this.uow.parts.byIds(result.partIds)) as Part[];
                result.partIds.forEach((partId) => {
                    const part = parts.filter((part) => part.id === partId)[0];
                    this.addAssemblyDetail(this.buildAssembly, part, 1);
                });
                await this.save();
                this.getDataLines();
                this.saving = false;
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }

    addAssemblyDetail(assembly?: any, part?: any, quantity?: number) {
        const line = this.uow.buildAssemblyDetails.createEntity() as BuildAssemblyDetail;
        line.buildAssemblyId = assembly.id;
        const lineNumber = this.details.length > 0 ? (_.maxBy(this.details, 'lineNumber') as any).lineNumber + 1 : 1;
        line.lineNumber = lineNumber;
        if (part) {
            line.partId = part.id;
            line.partNumber = part.partNumber;
            line.description = part.description;
        }
        line.quantity = quantity;
        return line;
    }

    async submit() {
        const success = await Promise.resolve(this.save());
        let pONumber = '0';
        if (!success) return;

        const negativeCheck =
            this.details.filter((x) => {
                if (x.quantity < 0 && !x.notes) return x;
            }).length > 0;

        if (!!negativeCheck) {
            await alert(`Negative lines require a note indicating which built date they are negating.`, `${this.appInfo.settings.company}`);
            return;
        }

        if (!this.buildAssembly.createPO) {
            const success = await confirm('Are you sure you want to submit this Build Assembly without creating a PO?', this.appInfo.settings.company);
            if (!success) return;
        }

        if (this.buildAssembly.createPO) {
            const result = await confirm(
                `Build Assembly is marked to create PO.  This will generate a PO and build details will be incremented when PO is received.`,
                `${this.appInfo.settings.company}`
            );
            if (!result) return;

            this.appInfo.pleaseWaitShow();
            let purchaseOrder = this.uow.purchaseOrders.createEntity() as PurchaseOrder;
            purchaseOrder.reportGuid = crypto.randomUUID();
            purchaseOrder.statusId = 1;
            purchaseOrder.pONumber = (await this.utility.getNextOrderNumber()) as any;
            pONumber = purchaseOrder.pONumber;
            purchaseOrder.createdById = this.auth.currentUser.id;
            purchaseOrder.createDate = new Date();
            purchaseOrder.pODate = new Date();
            purchaseOrder.vendorId = this.buildAssembly.vendorId;
            purchaseOrder.note = this.buildAssembly.notes;
            this.buildAssembly.purchaseOrderId = purchaseOrder.id;
            // purchaseOrder.shipToId = this.buildAssembly.shipToId;
            await this.uow.commit();

            for (let index = 0; index < this.details.length; index++) {
                const detail = this.details[index];
                // console.log(detail);
                if (this.buildAssembly.createPO) {
                    const aliases = await this.uow.getAliasByPartId(detail.partId);
                    await this.addPurchaseOrderLine(detail.part, detail.quantity, purchaseOrder, aliases, detail);
                }
            }

            await this.uow.commit();
            this.appInfo.pleaseWaitHide();
        }

        this.appInfo.pleaseWaitShow();
        let detailIds = [];
        this.details.forEach((detail) => {
            detail.created = new Date();
            detail.status = 1;
            detailIds.push(detail.id);
        });
        await this.uow.commit();

        this.buildAssembly.statusId = 2;
        await this.save();

        // call to utility to process the order line parts
        await this.utility.processBuildAssemblyDetails(detailIds);
        this.appInfo.pleaseWaitHide();

        if (this.buildAssembly.createPO) {
            await alert(`Purchase Order#: ${pONumber} created`, `${this.appInfo.settings.company}`);
        }
    }

    async addPurchaseOrderLine(part?: any, quantity?: number, purchaseOrder?: any, aliases?: any, detail?: any) {
        const line = this.uow.purchaseOrderLines.createEntity() as PurchaseOrderLine;
        line.lineNumber = (<PurchaseOrder>purchaseOrder).getNextLineNumber();
        // console.log(aliases);

        if (part) {
            const alias = _.find(
                aliases.filter((x) => {
                    if (!x.deleted) return x;
                }),
                { vendorId: this.buildAssembly.vendorId, partAliasTypeId: PartAliasType.Types.PurchaseOrder }
            );
            // console.log(alias);
            line.partAliasId = alias ? alias.id : null;
            line.partId = part.id;
            line.partNumber = part.partNumber;
            line.mfgPartNumber = alias ? alias.partNumber : part.mfgPartNumber ? part.mfgPartNumber : part.partNumber;
            line.description = alias ? alias.description : part.mfgDescription ? part.mfgDescription : part.description;
            line.cost = alias ? alias.cost : part.cost;
            line.packageQuantity = alias ? alias.packageQuantity : null;
            line.purchaseOrderLineItemId = alias ? alias.quickBooksLineItemId : PurchaseOrderLineItem.Items.Materials;
            console.log('NOTES', detail.notes);
            line.note = detail.notes;
        }
        line.purchaseOrderId = purchaseOrder.id;
        line.quantity = quantity;
        if (part?.vendorId) {
            const vendor = (await this.uow.vendors.byId(part.vendorId)) as Vendor;
            if (vendor.defaultLineItemId) line.purchaseOrderLineItemId = vendor.defaultLineItemId;
        }
        return line;
    }

    async save() {
        const success = await Promise.resolve(this.validate());
        if (!success) return false;
        this.isToastVisible = true;
        await this.uow.commit();
        if (this.assemblyId === 'new') {
            this.assemblyId = this.buildAssembly.id;
            this.router.navigate(['/build-assemblies/' + this.buildAssembly.id]);
        }
        return true;
    }

    cancel() {
        this.uow.rollback();
        this.close();
    }

    close() {
        try {
            this.router.navigate(['/build-assemblies/overview']);
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }
    closeDialog() {
        if (this.showAsDialog) {
            this.uow.rollback();
            this.result.next({});
        }
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
